<h2 mat-dialog-title>Uitslag invoeren</h2>
<mat-dialog-content>
  <mat-grid-list cols="5" rowHeight="12:7">

    <mat-grid-tile colspan="2">
      <div class="w-100" style="font-size: 16px;">
        <b>{{ data.group.name }} {{ data.round.name }}</b>
      </div>
    </mat-grid-tile>

    @for (gameNum of [1, 2, 3]; track gameNum) {
      <mat-grid-tile>
        <button type="button" class="btn btn-primary btn-lg" (click)="set21(1, gameNum)">21</button>
      </mat-grid-tile>
    }
    <mat-grid-tile colspan="2">
      <div class="w-100" [ngClass]="{'winner': isValidResult == 1}">
        <app-team-display
          [team]="data.match.team1"
          [event]="data.event"
          [tournament]="data.tournament"
          [inline]="false">
        </app-team-display>
      </div>
    </mat-grid-tile>

    @for (game of result.games; track $index; let i = $index) {
      <mat-grid-tile>
        <mat-form-field appearance="outline">
          <input matInput
                 type="number"
                 min="0"
                 max="30"
                 [(ngModel)]="game.score1"
                 (blur)="complementScores()"
                 (ngModelChange)="validateResult()"
                 [tabindex]="i * 2 + 1">
        </mat-form-field>
      </mat-grid-tile>
    }

    <mat-grid-tile colspan="2">
      <div class="w-100" [ngClass]="{'winner': isValidResult == -1}">
        <app-team-display
          [team]="data.match.team2"
          [event]="data.event"
          [tournament]="data.tournament"
          [inline]="false">
        </app-team-display>
      </div>
    </mat-grid-tile>

    @for (game of result.games; track $index; let i = $index) {
      <mat-grid-tile>
        <mat-form-field appearance="outline">
          <input matInput
                 type="number"
                 min="0"
                 max="30"
                 [(ngModel)]="game.score2"
                 (blur)="complementScores()"
                 (ngModelChange)="validateResult()"
                 [tabindex]="i * 2 + 2">
        </mat-form-field>
      </mat-grid-tile>
    }
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>

    @for (gameNum of [1, 2, 3]; track gameNum) {
      <mat-grid-tile>
        <button type="button" class="btn btn-primary btn-lg" (click)="set21(2, gameNum)">21</button>
      </mat-grid-tile>
    }

  </mat-grid-list>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="onAnnulerenClick()">Annuleren</button>
  <button mat-button [disabled]="isValidResult == 0" [mat-dialog-close]="result">Opslaan</button>
</mat-dialog-actions>
